module.exports = __webpack_public_path__ + "static/media/781eab81-0962-477d-a919-cc6165646ead.74c0250c.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/781eab81-0962-477d-a919-cc6165646ead.jpg
// module id = 829
// module chunks = 0